import MDEditor from "@uiw/react-md-editor";
import { useState } from "react";
import { Button, Card } from "react-bootstrap";
import { IGlobalContextProps } from "./GlobalContext";
import MiscService from "services/MiscService";

import './styles/MarkdownEditor.scss';

export interface IMarkdownEditorProps {
    onChange: (newVal: string) => void;
    globalContextRef: IGlobalContextProps;
    className?: string;
    noun?: string;
    value?: string;
    allowUploads?: boolean;
    height?: number;

}

const MarkdownEditor = (props: IMarkdownEditorProps) => {
    const [editing, setEditing] = useState(false);
    const [uploading, setUploading] = useState(false);

    const insertToTextArea = (intsertString: string) => {
        const textarea = document.querySelector('.w-md-editor-text-input') as HTMLTextAreaElement;

        if (!textarea) {
            return null;
        }

        let sentence = textarea.value;
        const len = sentence.length;
        const pos = textarea.selectionStart;
        const end = textarea.selectionEnd;

        const front = sentence.slice(0, pos);
        const back = sentence.slice(pos, len);

        sentence = front + intsertString + back;

        textarea.value = sentence;
        textarea.selectionEnd = end + intsertString.length;

        return sentence;
    };

    const onImagePasted = async (event: any, dataTransfer: DataTransfer, setMarkdown: (newVal: string) => void) => {
        const clipboardData = event.clipboardData;

        if (clipboardData) {
            const items = clipboardData.items;
            let hasImage = false;

            for (let i = 0; i < items.length; i++) {
                const item = items[i];

                if (item.kind === 'string') {
                    continue;
                }
                else if (item.kind === 'file') {
                    const file = item.getAsFile();

                    if (file && file.type.startsWith('image/')) {
                        hasImage = true;
                        setUploading(true);
                        const formData = new FormData();
                        const fileSize = file.size;
                        const megs = fileSize / 1048576;

                        if (megs < 25) {
                            formData.append("file", file);
                            const accessToken = await props.globalContextRef.getAccessTokenAsync();
                            const url = await MiscService.uploadMarkdownFileAsync(accessToken, formData);
                            const insertedMarkdown = insertToTextArea(`![](${url})`);

                            if (insertedMarkdown) {
                                setMarkdown(insertedMarkdown);
                            }

                            setUploading(false);
                        }
                    }
                }
            }

            if (hasImage) {
                event.preventDefault();
            }
        }
    };

    return (
        <Card data-color-mode="light" className={`${uploading ? "uploading" : ""}`}>
            <Card.Body>
                {
                    editing &&
                    <>
                        <MDEditor
                            className={`${uploading ? "uploading" : ""}`}
                            height={props.height || 200}
                            onPaste={async (event) => {
                                if (props.allowUploads && editing) {
                                    await onImagePasted(event, event.clipboardData, props.onChange);
                                }
                            }}
                            onDrop={async (event) => {
                                event.preventDefault();
                                if (props.allowUploads && editing) {
                                    await onImagePasted(event, event.dataTransfer, props.onChange);
                                }
                            }}
                            value={props.value}
                            onChange={(val) => props.onChange(val ?? "")} />
                        <Button
                            style={{ width: "100%", height: "100%" }}
                            onClick={
                                () => setEditing(false)}>Close {props.noun && props.noun + " "}Editor</Button>
                    </>
                }
                {
                    !editing &&
                    <div onClick={() => { setEditing(true); }}>
                        <MDEditor.Markdown
                            source={props.value}
                            style={{
                                minHeight: "50px"
                            }} />
                    </div >
                }
            </Card.Body>
        </Card>
    );
}

export default MarkdownEditor;